import { Participant, Room } from 'livekit-client';
import { Viewer } from 'features/ParticipantItem/presenters/Speaker';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { useParticipantSubscriptions } from 'hooks/useParticipantSubscriptions';
import { useParticipantElementRefs } from 'hooks/useParticipantElementRefs';
import { participantListOrderSort } from 'useCase';
import { ParticipantsContainer, ParticipantScrollableContainer, ParticipantWrapper, ViewerParticipant } from './view';

interface Props {
    participants: Participant[];
    room?: Room;
    speakerParticipantId?: string;
    isHideSpeakingBorder?: boolean;
}

export const ParticipantsList = ({ participants, room, speakerParticipantId, isHideSpeakingBorder }: Props) => {
    const { checkIsHandRaised } = useRaiseHand();
    const sortedParticipants = participantListOrderSort(participants, checkIsHandRaised);

    const { setElementRef } = useParticipantSubscriptions({
        room,
        participants: sortedParticipants,
        maxVisible: 8,
        isSidebarMode: true,
        speakerParticipantId,
        threshold: 0.6,
    });

    const elementRefs = useParticipantElementRefs(setElementRef, sortedParticipants);

    return (
        <ParticipantScrollableContainer>
            <ParticipantsContainer>
                {sortedParticipants.map((participant) => {
                    return (
                        <ParticipantWrapper
                            key={participant.identity}
                            ref={elementRefs.get(participant.identity)}
                            data-participant-id={participant.identity}
                        >
                            <ViewerParticipant
                                participant={participant}
                                PresenterComponent={Viewer}
                                isHideSpeakingBorder={isHideSpeakingBorder}
                            />
                        </ParticipantWrapper>
                    );
                })}
            </ParticipantsContainer>
        </ParticipantScrollableContainer>
    );
};
